export class PersonModel {
  constructor({ id, name, label, fullName }) {
    this.id = id;
    this.name = name ?? fullName;
    this.label = label ?? fullName ?? name;
    this.fullName = fullName ?? name ?? label;
  }

  static fromJson(json) {
    const name = json?.responsavel?.nomeCompleto ?? json?.nomeCompleto ?? json?.name;
    return new PersonModel({
      id: json?.colaborador_id ?? json?.responsavel?.id ?? json?.id,
      name,
      label: name,
      fullName: name,
    });
  }

  /** Used by InjectionActivityModel.toRemote() for equipe payload (colaborador_id). */
  minimalToRemote() {
    return { colaborador_id: this.id };
  }
}
